import { render, staticRenderFns } from "./LiveIconParts.vue?vue&type=template&id=8b95f920&scoped=true"
import script from "./LiveIconParts.vue?vue&type=script&lang=ts"
export * from "./LiveIconParts.vue?vue&type=script&lang=ts"
import style0 from "./LiveIconParts.vue?vue&type=style&index=0&id=8b95f920&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8b95f920",
  null
  
)

export default component.exports